import styled from 'styled-components'

import { Button } from 'components/Button'

import closeSvg from 'assets/images/close-icon.svg'

import { Color } from 'root-constants'

type TWrapperProps = {
  isVisible: boolean
}

export const StyledCheckoutPrimer = {
  Wrapper: styled.div<TWrapperProps>`
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
    max-width: 360px;
    margin: 50px auto 0;
    padding: 0 20px 60px;
    text-align: center;
  `,
  Title: styled.h1`
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
  `,
  CloseButton: styled.button`
    padding: 0;
    display: block;
    position: absolute;
    top: 65px;
    right: 15px;
    width: 24px;
    height: 24px;
    border: none;
    outline: none;
    cursor: pointer;
    background-size: 24px 24px;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(${closeSvg});
  `,
  TotalAmount: styled.p`
    margin-bottom: 30px;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;

    strong {
      color: ${Color.PRIMARY};
    }
  `,
  PaymentContainer: styled.div``,
  Button: styled(Button)`
    height: 55px;
  `,
  Image: styled.img`
    margin: 24px auto;
    max-width: 256px;
  `,
  Text: styled.p`
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: rgba(19, 29, 48, 0.5);
  `,
  ThreeDSecureIframe: styled.iframe`
    height: calc(var(--full-height, 100vh) - 50px) !important;
    padding: 15px;
  `,
}
